module.exports = __webpack_public_path__ + "/images/ico-color-card-secure.04832d5.svg";